import { CustomerPortalRequestState } from "../../../api/models/unified";
import { RequestStateBackground } from "../../../helpers/requestHelper";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface RequestStateTagProps {
  state: CustomerPortalRequestState;
}

const RequestStateTag = ({ state }: RequestStateTagProps) => {
  const { tRequest } = useCustomTranslation();

  return (
    <div
      className={`rounded-lg px-2 py-1 text-[14px]/[21px] leading-5 text-white ${RequestStateBackground[state]}`}
    >
      {tRequest(`state_${state}`)}
    </div>
  );
};

export default RequestStateTag;
